
// SVG Icon: compare-right-panel
export default { id: "terriajs-compare-right-panel" };
export const id = "terriajs-compare-right-panel";
export const name = "compare-right-panel";
